export default "/signup/_next/static/chunks/fonts/CircularStd-Bold-c35da9cdcefd0d8b8f1c495e5c0d9473.otf";